import {BaseIntDTO} from '../_baseIntDTO.interface';

export interface RangeDTO extends BaseIntDTO {
  min: number;
  max: number;
}
